import { IOptionMenuItem } from '@/document-edit/assembler/types/option-menu-item';
import { IDropdownItem } from '@/editor/types';
import { CellType, ENodeType, ETextType, ERowType } from '@/editor/types/enums';

export const addNodeItems: IOptionMenuItem[] = [
  {
    icon: 'editor-text-icon',
    title: 'text',
    callback: ENodeType.Text,
    preventFillIcon: true,
  },
  {
    icon: 'editor-image-icon',
    title: 'image',
    callback: ENodeType.Image,
    preventFillIcon: true,
  },
  {
    icon: 'editor-sidebyside',
    title: 'image-and-text',
    callback: ERowType.SideBySide,
    preventFillIcon: true,
  },
  {
    icon: 'editor-columns',
    title: 'columns-layout',
    callback: ERowType.Columns,
    preventFillIcon: true,
  },
  {
    icon: 'editor-table-icon',
    title: 'table',
    callback: ENodeType.Table,
    preventFillIcon: true,
  },
  {
    icon: 'editor-divider-icon',
    title: 'divider',
    callback: ENodeType.Divider,
    preventFillIcon: true,
  },
];

export const textTypeItems: IDropdownItem[] = [
  {
    text: 'normal-text',
    itemClass: 'paragraph',
    type: ETextType.Paragraph,
  },
  {
    text: 'heading-1',
    itemClass: 'heading1',
    type: ETextType.Heading1,
  },
  {
    text: 'heading-2',
    itemClass: 'heading2',
    type: ETextType.Heading2,
  },
  {
    text: 'subheading',
    itemClass: 'subheading',
    type: ETextType.Subheading,
  },
  {
    text: 'small-text',
    itemClass: 'label',
    type: ETextType.Label,
  },
];

export const cellTypeIcon = {
  [CellType.ImageOnly]: 'editor-columns-image-only',
  [CellType.TextOnly]: 'editor-columns-text-only',
  [CellType.ImageAndText]: 'editor-columns-image-and-text',
};
